import { getLocalStorageUser } from "../session/auth.service";
import starlightIcon from "../../assets/img/starlight-icon-light.svg";
import kannactIcon from "../../assets/img/kannact-icon.svg";
import starlightLogo from "../../assets/img/starlight-logo.svg";
import kannactLogo from "../../assets/img/kannact-logo-detailed.svg";

const setIcon = () =>
	getLocalStorageUser()?.brandName === "Kannact" ? kannactIcon : starlightIcon;

const setIconAlt = () => `${getLocalStorageUser()?.brandName} logo`;

const setLogo = () =>
	getLocalStorageUser()?.brandName === "Kannact" ? kannactLogo : starlightLogo;

const setSupportEmail = () =>
	window.location.hostname.includes("kannact")
		? "support@kannact.com"
		: "support@hellostarlight.com";

const setLoginLogo = () =>
	window.location.hostname.includes("kannact") ? kannactLogo : starlightLogo;

const setAuth0Domain = () =>
	window.location.hostname.includes("kannact")
		? process.env.REACT_APP_AUTH0_DOMAIN_KANNACT
		: process.env.REACT_APP_AUTH0_DOMAIN_STARLIGHT;

const setAuth0ClientId = () =>
	window.location.hostname.includes("kannact")
		? process.env.REACT_APP_AUTH0_CLIENT_ID_KANNACT
		: process.env.REACT_APP_AUTH0_CLIENT_ID_STARLIGHT;

const setTheme = () => {
	// Get brand name
	const brandName = getLocalStorageUser()?.brandName
		? getLocalStorageUser().brandName
		: window.location.hostname.includes("kannact")
			? "Kannact"
			: "Starlight";

	// Load browser tab icon (favico)
	const link = document.createElement("link");
	link.rel = "icon";
	link.href = brandName === "Kannact" ? "./kannact-favicon.ico" : "./starlight-favicon.ico";
	document.head.appendChild(link);

	// Load browser tab title
	document.title = brandName;

	// Load theme
	document.body.setAttribute("data-theme", brandName);
};

export const ThemeService = {
	setIcon,
	setIconAlt,
	setLogo,
	setSupportEmail,
	setLoginLogo,
	setAuth0Domain,
	setAuth0ClientId,
	setTheme,
};
